import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react';

/** Text for screen readers only. */
export function VisuallyHidden({ children, ...rest }: HTMLAttributes<HTMLSpanElement>) {
  return <span {...rest} className={['qm-sr-only', rest.className].filter(Boolean).join(' ')}>{children}</span>;
}

/** First focusable element on every page (WCAG 2.4.1). */
export function SkipLink({ href = '#main', children }: { href?: string; children: ReactNode }) {
  return <a className="qm-skip" href={href}>{children}</a>;
}

/** Icon-only button: an accessible name is mandatory. */
export function IconButton({ label, children, className, type = 'button', ...rest }: ButtonHTMLAttributes<HTMLButtonElement> & { label: string }) {
  return (
    <button {...rest} type={type} aria-label={label} title={label} className={['qm-icon-button', className].filter(Boolean).join(' ')}>
      {children}
    </button>
  );
}
